import { atom } from 'recoil';
// 모달에서 사용할 데이터의 타입을 정의
export interface ModalDataType {
  [pageNumber: string]: {
    name?: string;
    status?: string;
    manager?: string;
    contact?: string;
  };
}

// 모달 상태의 타입 정의
export type ModalStateType = {
  isOpen: boolean;
  title: string;
  content: JSX.Element | null;
  data?: any;
  handleInputChange?: (field: string, value: string) => void;
  onSubmit?: () => void;
  showSubmitButton: boolean;
  showNextPageButton?: boolean;
  pageData?: { [key: string]: any };
  totalPages: number;
  currentPage: number;
  nextContent?: JSX.Element;
  formData: any;
};

export const modalState = atom<ModalStateType>({
  key: 'modalState',
  default: {
    isOpen: false,
    title: '',
    content: null,
    data: null,
    onSubmit: () => {},
    showSubmitButton: false,
    showNextPageButton: false,
    pageData: {},
    totalPages: 1,
    currentPage: 1,
    formData: null,
  },
});
